import { render, staticRenderFns } from "./loginMobile.vue?vue&type=template&id=224a48e2"
import script from "./loginMobile.vue?vue&type=script&lang=js"
export * from "./loginMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports